module.exports = __webpack_public_path__ + "static/media/imbe.2bf99fae.png";